<template>
  <van-popup
    v-model="kaiguan"
    :style="{background:'transparent'}"
    :close-on-click-overlay="false"
    @open="getRecordInfo"
  >
    <div class="get-sw" v-if="msg.type === 'GWK'">
      <p class="title">请填写任一种联系方式</p>
      <div class="mt border-color">
        <input type="number" class="Input" placeholder="手机号" maxlength="11" v-model="telphone" />
      </div>
      <div class="mt border-color">
        <input type="number" class="Input" placeholder="QQ号" v-model="qqnum" />
      </div>
      <van-button
        type="primary"
        size="large"
        color="linear-gradient(to bottom, #e28215,#dc580d)"
        class="btn"
        @click="handleEnter"
      >确定</van-button>
    </div>
    <div class="get-sw" v-else>
      <p class="title">请填写收货信息</p>
      <div class="mt border-color">
        <input type="text" class="Input" placeholder="请输入你的姓名" v-model="name" />
      </div>
      <div class="mt border-color">
        <input type="number" class="Input" placeholder="请输入联系手机" maxlength="11" v-model="phone" />
      </div>
      <textarea
        type="text"
        class="mt text"
        placeholder="请输入邮寄地址"
        v-model="address"
        style="resize:none"
      ></textarea>
      <van-button
        type="primary"
        size="large"
        color="linear-gradient(to bottom, #e28215,#dc580d)"
        class="btn"
        @click="handleClick"
      >确定</van-button>
    </div>
    <button class="cancel" @click.stop="closeGetSW"></button>
  </van-popup>
</template>

<script>
export default {
  name: "GetSW",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    msg: {
      type: Object,
      default: function() {
        return {
          type: ""
        };
      }
    }
  },
  data: () => ({
    name: "",
    phone: "",
    address: "",
    qqnum: "",
    telphone: ""
  }),
  computed: {
    kaiguan: {
      get: function() {
        return this.show;
      },
      set: function() {
        return;
      }
    }
  },
  methods: {
    closeGetSW() {
      this.name = "";
      this.phone = "";
      this.address = "";
      this.qqnum = "";
      this.telphone = "";
      this.$parent.open("getSW");
    },
    async handleClick() {
      if (!this.name || !this.phone || !this.address) {
        this.$toast({
          message: "请填写完整信息",
          duration: 800,
          position: "middle",
          type: "fail",
          className: "tan"
        });
        return;
      }
      let { data } = await this.$api.activity.fillAddress({
        drawId: this.msg.id || this.msg.drawId,
        address: `${this.name}/${this.phone}/${this.address}`
      });
      if (data.code === 0) {
        let that = this;
        this.$toast({
          message: "奖品将在15个工作日内寄出\n请耐心等候",
          duration: 800,
          position: "middle",
          className: "tan",
          type: "success",
          onClose: function() {
            that.closeGetSW();
          }
        });
      }
    },
    async handleEnter() {
      if (!this.qqnum && !this.telphone) {
        this.$toast({
          message: "最少填写一种联系方式",
          duration: 800,
          position: "middle",
          type: "fail",
          className: "tan"
        });
        return;
      }
      let { data } = await this.$api.activity.fillAddress({
        drawId: this.msg.id || this.msg.drawId,
        address: `${this.telphone}/${this.qqnum}`
      });
      if (data.code === 0) {
        let that = this;
        this.$toast({
          message: "请耐心等候工作人员联系",
          duration: 800,
          position: "middle",
          className: "tan",
          type: "success",
          onClose: function() {
            that.closeGetSW();
          }
        });
      }
    },
    async getRecordInfo() {
      let { data:RecordInfo } = await this.$api.activity.recordInfo({
        prizeType: this.msg.type
      });
      if (RecordInfo.code === 0) {
        let { address } = RecordInfo.data;
        if (this.msg.type === "GWK") {
          this.qqnum = address.split("/")[1];
          this.telphone = address.split("/")[0];
          return;
        }
        this.name = address.split("/")[0];
        this.phone = address.split("/")[1];
        this.address = address.split("/")[2];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.get-sw {
  width: 800px;
  padding: 50px;
  text-align: center;
  background: rgba(255, 255, 255, 1);
  border: 0.1rem solid rgba(255, 255, 255, 1);
  box-shadow: inset 0px 3px 21px 0px rgba(244, 160, 68, 0.78);
  font-size: 45px;
  border-radius: 30px;
  position: relative;
  margin-bottom: 80px;
  .title {
    text-align: center;
    margin-bottom: 40px;
  }
  .mt {
    margin-bottom: 40px;
  }
  .border-color {
    border: 1px solid #c6c6c6;
    border-radius: 10px;
  }
  .Input {
    width: 100%;
    height: 100px;
    font-size: 30px;
    padding-left: 35px;
  }
  .btn {
    cursor: pointer;
    height: 100px;
    line-height: 100px;
    font-size: 35px;
    border-radius: 50px;
  }
  .text {
    box-sizing: border-box;
    font-size: 30px;
    padding-left: 35px;
    padding-top: 25px;
    width: 100%;
    border: 1px solid #c6c6c6;
    border-radius: 10px;
    height: 176px;
    outline: none;
  }
}
.cancel {
  display: block;
  cursor: pointer;
  margin: 0 auto;
  height: 60px;
  width: 60px;
  background: url("../assets/guanbi-min.png") no-repeat;
  background-size: 100% 100%;
}
</style>